import React from 'react'
import IntegrationHero from './integrationHero/IntegrationHero'
import IntegrationTestimonial from './integrationTestimonial/IntegrationTestimonial'
import IntegrationService from './integrationService/IntegrationService'
import IntegrationFaster from './integrationFaster/IntegrationFaster'
import IntegrationChoose from './integrationChoose/IntegrationChoose'
import IntegrationImplementation from './integrationImplementation/IntegrationImplementation'
import IntegrationContinuous from './integrationContinuous/IntegrationContinuous'
import IntegrationCapability from './integrationCapability/IntegrationCapability'
import IntegrationBenefit from './integrationBenefit/IntegrationBenefit'

export default function IntegrationPage() {
  return (
    <div>
        <IntegrationHero/>  
         <IntegrationContinuous/>
         <IntegrationCapability/>
         <IntegrationBenefit/>
        <IntegrationImplementation/>
        <IntegrationChoose/>  
        <IntegrationFaster/>   
        <IntegrationTestimonial/>
        <IntegrationService/>
    </div>
  )
}
